import { render, staticRenderFns } from "./detail-hearder.vue?vue&type=template&id=30f9ee9e&"
import script from "./detail-hearder.vue?vue&type=script&lang=js&"
export * from "./detail-hearder.vue?vue&type=script&lang=js&"
import style0 from "./detail-hearder.vue?vue&type=style&index=0&id=30f9ee9e&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports